import "./Hero.css";
import BackgroundVideo from "./BackgroundVideo";
import { FaShieldAlt, FaPhoneAlt, FaArrowRight, FaCheckCircle } from "react-icons/fa";

export default function Hero() {
  const poster = "/videos/security-bg.jpg";

  return (
    <section
      className="hero"
      id="home"
      style={{
        backgroundImage: `url(${poster})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <BackgroundVideo />
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="hero-badge">
          <FaShieldAlt className="badge-shield-icon" />
          <span>Entreprise Agréée CNAPS • Sécurité Privée Île-de-France</span>
        </div>

        <h1 className="hero-title">
          Wourou Sécurité
          <span className="hero-title-accent">Protection & Surveillance 24/7</span>
        </h1>

        <p className="hero-subtitle">
          Spécialiste de la surveillance cynophile (maître-chien), de la sécurité incendie SSIAP
          et du gardiennage de sites sensibles, chantiers et événements.
        </p>

        <div className="hero-actions">
          <a href="#contact" className="btn-primary hero-btn-primary">
            Demander un devis gratuit <FaArrowRight />
          </a>
          <a href="tel:+33602615612" className="hero-btn-phone">
            <FaPhoneAlt /> Astreinte 24/7 : 06 02 61 56 12
          </a>
        </div>

        <div className="hero-guarantees">
          <div className="guarantee-item">
            <FaCheckCircle className="check-icon" /> Réactivité sous 24h
          </div>
          <div className="guarantee-item">
            <FaCheckCircle className="check-icon" /> Binôme Cynophile d'Élite
          </div>
          <div className="guarantee-item">
            <FaCheckCircle className="check-icon" /> Conformité Art. L 612-14 CSI
          </div>
        </div>
      </div>
    </section>
  );
}
